<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/rAZxjw/cover.jpeg?1684515197220" alt="This image is the cover for the book Sunset Loulan, Volume 1"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sunset Loulan, Volume 1
      </h1>
      <p class="bookDescription body article font2">
        <p><strong>The desert was filled with wind and sand as sharp as blades. The once prosperous lands were actually unable to overcome the changes that occurred every hundred years. If they were a person, they would be the same. They were identical twins. One was intelligent, the other was dull, and even though they walked on two different paths, they could not turn back.</strong></p><p> In order to save the princess, the two brothers finally decided to join hands against the enemy. In the cycle of five hundred years, some people lived forever while others buried in the sand. The sariras were reincarnated into adulthood, but it was difficult for them to become buddhas again.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Shi BaMao, Babel Novel
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Funstory
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d2e21162